export const createMessengerV2LiveKitE2eeWorker = () => {
  if (typeof Worker === 'undefined') return null;
  return new Worker(new URL('livekit-client/e2ee-worker', import.meta.url), {
    type: 'module',
  });
};

export default createMessengerV2LiveKitE2eeWorker;
